/* eslint-disable react/require-default-props */
import {
    TablePaginationProps,
} from '@mui/material/TablePagination'
import {
    gridPaginationRowCountSelector,
    useGridApiContext,
    useGridSelector,
} from '@mui/x-data-grid-pro'
import {
    useCallback,
} from 'react'
import SkyNetPagination, {
    SkyNetPaginationMode,
} from 'app/shared-components/SkyNetPagination'
import useSkyNetObjectProfileContext
    from 'app/PoC/DataGridDemoPages/components/SkyNetObjectProfile/SkyNetObjectProfileContext'

/* Paging that use current page stored on context SkyNetObjectProfile
*  necessary for sharing between main and details view */
function SkyNetMasterDataGridPagination({
    className,
    mode = SkyNetPaginationMode.NUMERICAL,
    useCard = true,
    rowsPerPage = 25,
}: Pick<TablePaginationProps, 'className'> & {
    mode?: SkyNetPaginationMode,
    useCard?: boolean,
    rowsPerPage?: number,
}) {
    const apiRef = useGridApiContext()
    const {
        page,
        setPage,
    } = useSkyNetObjectProfileContext()

    const total = useGridSelector(apiRef, gridPaginationRowCountSelector)

    const onChange = useCallback((_event, newPage) => {
        setPage(newPage - 1)
        apiRef.current.setPage(newPage - 1)
    }, [
        apiRef,
        setPage,
    ])

    return (
        <div className={className}>
            <SkyNetPagination
                total={total}
                rowsPerPage={rowsPerPage}
                page={page + 1}
                mode={mode}
                useCard={useCard}
                onChange={onChange}
            />
        </div>
    )
}

export default SkyNetMasterDataGridPagination
